import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import {
  Table,
  Pagination,
  Tooltip,
  Input,
  DatePicker,
  Select,
  Modal,
} from 'components';
import History from './history';
import Payments from './payments';
import { HistoryIcon, Payments2Icon } from 'assets/icons';
import PaymentsServices from './payments-services';

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
}

const TABS = {
  HISTORY: 1,
  PAYMENTS: 2,
  PAYMENT_SERVICES: 3,
};

class Reports extends React.Component<Props> {
  state = {
    tab: TABS.HISTORY,
  };

  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Reportes',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });
  }

  setTab = (tab: number) => {
    this.setState({
      tab,
    });
  };

  render() {
    const { tab } = this.state;
    const is_client = this.props.user?.level_id == Constants.LEVELS.CLIENT;

    return (
      <div id="client-reports">
        <div className="row row-buttons">
          <div className="col-md-4 text-center">
            <button
              className={`btn btn-report ${tab == TABS.HISTORY ? 'active' : ''}`}
              onClick={() => this.setTab(TABS.HISTORY)}
            >
              <img src={HistoryIcon} />
              <p>Historial de trámites</p>
            </button>
          </div>
          <div className="col-md-4 text-center">
            <button
              className={`btn btn-report ${tab == TABS.PAYMENTS ? 'active' : ''}`}
              onClick={() => this.setTab(TABS.PAYMENTS)}
            >
              <img src={Payments2Icon} />
              <p>Pagos realizados</p>
            </button>
          </div>
          {is_client && (
            <div className="col-md-4 text-center">
              <button
                className={`btn btn-report ${tab == TABS.PAYMENT_SERVICES ? 'active' : ''}`}
                onClick={() => this.setTab(TABS.PAYMENT_SERVICES)}
              >
                <img src={Payments2Icon} />
                <p>Pagos de servicios</p>
              </button>
            </div>
          )}
        </div>

        {tab == TABS.HISTORY && (
          <>
            {/*
							// @ts-ignore */}
            <History />
          </>
        )}

        {tab == TABS.PAYMENTS && (
          <>
            {/*
							// @ts-ignore */}
            <Payments />
          </>
        )}

        {tab == TABS.PAYMENT_SERVICES && (
          <>
            {/*
							// @ts-ignore */}
            <PaymentsServices />
          </>
        )}
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(Reports);
